"use client";

import { useAppSelector } from "@/store/hooks";
import { BlockGap, DefaultBackground } from "@/ui";
import { CTASideBySide } from "@/ui/call-to-action";
import { useRouter, useSearchParams } from "next/navigation";
import DecorativeLines from "./DecorativeLines";
import EditorialHeader from "./EditorialHeader";
import FeaturedDish from "./FeaturedDish";
import MenuItemCard from "./MenuItemCard";

export default function ChefsSpecial() {
  const router = useRouter();
  const searchParams = useSearchParams();
  const { data, loading, error } = useAppSelector((state) => state.content);

  // Loading state
  // if (loading) {
  //   return (
  //     <DefaultBackground
  //       decorativeElements={[]}
  //       positionMode="absolute"
  //       fullHeight={false}
  //     >
  //       <section className="relative overflow-hidden">
  //         <BlockGap />
  //         <div className="max-w-7xl mx-auto px-6 py-20">
  //           <div className="animate-pulse space-y-8">
  //             <div className="h-12 bg-gray-200 dark:bg-gray-700 rounded w-1/3 mx-auto" />
  //             <div className="h-6 bg-gray-200 dark:bg-gray-700 rounded w-2/3 mx-auto" />
  //             <div className="h-96 bg-gray-200 dark:bg-gray-700 rounded" />
  //           </div>
  //         </div>
  //         <BlockGap />
  //       </section>
  //     </DefaultBackground>
  //   );
  // }

  // Error state
  // if (error) {
  //   return (
  //     <DefaultBackground
  //       decorativeElements={[]}
  //       positionMode="absolute"
  //       fullHeight={false}
  //     >
  //       <section className="relative overflow-hidden">
  //         <BlockGap />
  //         <div className="max-w-4xl mx-auto px-6 py-20 text-center">
  //           <div className="bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg p-8">
  //             <h2 className="text-2xl font-bold text-red-900 dark:text-red-100 mb-4">
  //               Failed to Load Content
  //             </h2>
  //             <p className="text-red-700 dark:text-red-300 mb-6">{error}</p>
  //             <button
  //               type="button"
  //               onClick={() => window.location.reload()}
  //               className="px-6 py-3 bg-red-600 hover:bg-red-700 text-white rounded-lg transition-colors"
  //             >
  //               Reload Page
  //             </button>
  //           </div>
  //         </div>
  //         <BlockGap />
  //       </section>
  //     </DefaultBackground>
  //   );
  // }

  // No data or missing chefsSpecial state
  if (!data?.chefsSpecial) {
    return null;
  }

  // Success - render content
  return (
    <DefaultBackground
      decorativeElements={[]}
      positionMode="absolute"
      fullHeight={false}
    >
      <section className="relative overflow-hidden">
        {/* Decorative lines */}
        <DecorativeLines />
        <BlockGap />

        {/* Editorial header */}
        <EditorialHeader />

        {/* Featured dish */}
        {data.chefsSpecial.featuredDish && (
          <>
            <FeaturedDish data={data.chefsSpecial.featuredDish} />
            <BlockGap />
          </>
        )}

        {/* Two-column grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 mb-20 max-w-7xl mx-auto px-6">
          <div className="space-y-12">
            {(data.chefsSpecial.leftColumnItems || []).map((item) => (
              <MenuItemCard key={item.index} item={item} />
            ))}
          </div>
          <div className="space-y-12">
            {(data.chefsSpecial.rightColumnItems || []).map((item) => (
              <MenuItemCard key={item.index} item={item} />
            ))}
          </div>
        </div>

        {/* CTA: Side by Side */}
        <CTASideBySide
          onPrimaryClick={() => {}}
          onSecondaryClick={() => {
            const mode = searchParams.get("mode");
            const slug = searchParams.get("slug");
            const query = mode && slug ? `?mode=${mode}&slug=${slug}` : "";
            router.push(`/menu${query}`);
          }}
        />
        <BlockGap />
      </section>
    </DefaultBackground>
  );
}
